
import { Component, Vue } from 'vue-property-decorator';
import TopNavBar from '@/components/app/TopNavBar.vue';
import { State } from 'vuex-class';
import ListViewMenu from '@/components/app/ListViewMenu.vue';
import { DeviceInfo, DeviceType } from '@/types/device-info';
import DeviceInfoComponent from '@/components/devices/DeviceInfo.vue';
import DeviceTransferPlansSettings from '@/components/devices/settings/DeviceTransferPlansSettings.vue';
import { UserInfo } from '@/types/user-info';
import api from '@/modules/api';
import { Debounce } from '@/modules/decorators';
import UserSignupModel from '@/components/devices/settings/UserSignupModel.vue';
import _ from 'lodash';

@Component({
    components: {
        TopNavBar,
        ListViewMenu,
        'device-info': DeviceInfoComponent,
        DeviceTransferPlansSettings,
        UserSignupModel
    },
})
export default class DevicesTransfer extends Vue {
    searchMembers: UserInfo[] = [];
    member: Partial<UserInfo> = {};
    selectedDevice: Partial<DeviceInfo> = {};
    valueSelected = false;
    userModel = false;
    DeviceTypeenum = DeviceType;
    userNotExist = false;

    @State('devices')
    devices!: DeviceInfo[];

    @State('devicesFetched')
    devicesFetched!: boolean;

    @State('searchName')
    searchName!: boolean;

    @State('device')
    current!: DeviceInfo;

    @State('user')
    user!: UserInfo;

    handleSave(e: Event) {
        e.preventDefault();              
    }
    changeState() {
        this.valueSelected = !this.valueSelected;  
    }
    getDevciceItem(devices: DeviceInfo[]) {
        return devices.filter((device: any) => {
            if(device.deviceType === this.DeviceTypeenum.AirboltGps) return device.text = device.name;
        })
    }
    @Debounce(500)
    async searchMember(email: string) {
        this.userNotExist = true;
        if (!_.isEmpty(this.member)) this.userNotExist = false;
        if (!email) {
            this.userNotExist = false;
            return;
        }
        const paginated = await api.loadUsers({
            page: 0,
            perPage: 10,
            filter: email,
        });

        this.searchMembers = paginated.data?.filter((user) => user._id !== this.user._id );

        if(!this.searchMembers.length) {
            this.userNotExist = true;
        }
    }
    pickMember(member: UserInfo) {
        if (member === null || typeof member === 'string') return;
        this.member = member;
    }
    changeDevice(deviceName: string) {
        this.selectedDevice = this.devices.find((device: DeviceInfo) => device.name === deviceName) || {};
    }
    updateValueSelected(value: boolean) {
        this.valueSelected = value;
    }
    checkFormValue() {
        return _.isEmpty(this.member) || _.isEmpty(this.selectedDevice)
    }

}
